<template>
  <div class="three-container" ref="threeDom"></div>
</template>
<script>
import { Scene, layer } from "spritejs";
import { Cube, shaders, Mesh3d } from "sprite-extend-3d";
export default {
  data() {
    return {};
  },
  mounted() {
    let container = this.$refs.threeDom;

    let scene = new Scene({
      container,
      width: 600,
      height: 600,
      // autoRender: false,
      mode: "stickyWidth",
    });

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          scene.width = entry.contentBoxSize[0].inlineSize;
          scene.height = entry.contentBoxSize[0].blockSize;
        }
      }
    });

    resizeObserver.observe(container);

    const layer = scene.layer3d("fglayer", {
      camera: {
        fov: 35,
        z: 5,
      },
    });

    const program = layer.createProgram({
      ...shaders.NORMAL_GEOMETRY,
      cullFace: null,
    });

    const p = 1 / Math.sqrt(2);
    const model = {
      position: [
        -1,
        0,
        -p,
        1,
        0,
        -p,
        0,
        1,
        p,
        -1,
        0,
        -p,
        1,
        0,
        -p,
        0,
        -1,
        p,
        1,
        0,
        -p,
        0,
        -1,
        p,
        0,
        1,
        p,
        -1,
        0,
        -p,
        0,
        1,
        p,
        0,
        -1,
        p,
      ],
    };

    const sprite = new Mesh3d(program, {
      model,
      colors: "red blue green orange",
    });
    layer.append(sprite);

    sprite.animate([{ rotateY: 0 }, { rotateY: 360 }], {
      duration: 7000,
      iterations: Infinity,
    });

    sprite.animate([{ rotateZ: 0 }, { rotateZ: 360 }], {
      duration: 17000,
      iterations: Infinity,
    });

    sprite.animate([{ rotateX: 0 }, { rotateX: -360 }], {
      duration: 11000,
      iterations: Infinity,
    });

    layer.setOrbit();
  },
  
};
</script>
<style scoped>
.three-container {
  height: 100%;
  width: 100%;
}
</style>